import { useUsersStore } from '@/stores/index.js'
import { canAccessControlTower } from '@/utils/controlTower/access'

// Torre de Control esta limitada a una allowlist de correos (ver utils/controlTower/access.js).
// Con recarga directa a la URL el usuario puede no estar cargado aun: se espera a que llegue
// antes de decidir, para no expulsar a quien si tiene permiso.
export async function controlTowerGuard (to, from, next) {
  const usersStore = useUsersStore()
  if (!usersStore.current) {
    try {
      await usersStore.fetchCurrentForBoot()
    } catch (error) {
      console.error(error)
    }
  }
  if (canAccessControlTower(usersStore.current)) return next()
  return next({ name: 'navigation.home' })
}
